import { jwtDecode } from 'jwt-decode';
import { getOktaConfig } from '../storageHelpers/sessionStorageAccessors';

export const getOrgRefIdFromOktaConfig = () => {
  try {
    const oktaConfig = getOktaConfig();

    if (!oktaConfig) {
      throw new Error('Okta configuration is not available.');
    }

    const parsedConfig = JSON.parse(oktaConfig);
    const { state } = parsedConfig;

    if (!state || typeof state !== 'string') {
      throw new Error(
        'State is missing or not a valid string in Okta configuration.',
      );
    }

    const encodedJWT = state.split('@')[4];

    if (!encodedJWT) {
      throw new Error('Encoded JWT is not found in the state.');
    }

    const decodedJWT = jwtDecode(encodedJWT);

    if (!decodedJWT || !decodedJWT.login_hint) {
      throw new Error('Login hint is missing in the decoded JWT.');
    }

    return decodedJWT.login_hint;
  } catch (error) {
    console.error('Error retrieving orgRefId from Okta config:', error.message);
    return null; // Return null or handle the error as needed
  }
};

export default getOrgRefIdFromOktaConfig;
